import { Injectable } from '@angular/core';

import _cloneDeep from 'lodash-es/cloneDeep';
import _isEqual from 'lodash-es/isEqual';
import _forEach from 'lodash-es/forEach';
import _set from 'lodash-es/set';
import _unset from 'lodash-es/unset';

// Import RxJs required methods



@Injectable()
export class TravellerService {
    /**
     * isSameTraveller
     *
     * compare 2 Traveller
     * @param {string} _referenceTraveller : reference traveller
     * @param {string} _newTraveller : new traveller
     * @return {boolean} : true if same, false if not same traveller
     */
    public isSameTraveller(_referenceTraveller: any, _newTraveller: any): boolean {
        const referenceTraveller = _cloneDeep(_referenceTraveller);
        const newTraveller = _cloneDeep(_newTraveller);

        this.removeEmpty(referenceTraveller);
        this.removeEmpty(newTraveller);

        this.unsetProperties(referenceTraveller);
        this.unsetProperties(newTraveller);

        this.dobToBd(referenceTraveller);
        this.dobToBd(newTraveller);

        return _isEqual(referenceTraveller, newTraveller);
    }

    /**
     * getTravellerDifference
     * only get diff between TNR pax and Group Pax,
     * @param {string} _referenceTraveller : reference traveller (tnr)
     * @param {string} _newTraveller : new traveller (pnr)
     * @return {any} : object containing differences
     */
    public getTravellerDifference(_referenceTraveller: any, _newTraveller: any) {
        const referenceTraveller = _cloneDeep(_referenceTraveller);
        const newTraveller = _cloneDeep(_newTraveller);

        this.removeEmpty(referenceTraveller);
        this.removeEmpty(newTraveller);

        this.unsetProperties(referenceTraveller);
        this.unsetProperties(newTraveller);

        this.dobToBd(referenceTraveller);
        this.dobToBd(newTraveller);

        const output: any = {};

        _forEach(referenceTraveller, (_v: any, _k: any) => {
            if (!_isEqual(newTraveller[_k], _v)) {
                _set(output, _k, _v);
            }
        });

        return output;
    }

    public accronymType(_type: string): string {
        let output: string;
        switch (_type) {
            case "Adult":
                output = "ADT";
                break;
            case "Infant":
                output = "INF";
                break;
            case "Child":
                output = "CHD";
                break;
        }

        return output;
    }

    public dobToBd(_traveller: any): void {
        if (_traveller.dateOfBirth) {
            _set(_traveller, 'birthDate', _traveller.dateOfBirth);
            _unset(_traveller, 'dateOfBirth');
        }
    }

    public unsetProperties(_traveller: any): void {
        _unset(_traveller, 'booking');
        _unset(_traveller, 'journey');
        _unset(_traveller, 'age');
        _unset(_traveller, 'apisIndicator');
        _unset(_traveller, 'sfpdIndicator');
        _unset(_traveller, 'gender');
        _unset(_traveller, 'type');
        _unset(_traveller, 'personType');
        _unset(_traveller, 'code');
        _unset(_traveller, 'usesStock');
        _unset(_traveller, 'xID');
    }

    public removeEmpty(_traveller: any): void {
        Object.keys(_traveller).forEach((key) => {
            // If Object recall function, keep in mind : Array is Object in JS
            if (_traveller[key] && typeof _traveller[key] === 'object') {
                // Recursion
                this.removeEmpty(_traveller[key]);

                // If object is empty then delete it
                if (!Object.keys(_traveller[key]).length) {
                    delete _traveller[key];
                }
            }
            // If null delete property
            else if (_traveller[key] === null || _traveller[key] === '' || _traveller[key] === ' ') {
                delete _traveller[key];
            }
        });
        return _traveller;
    }

    public generateTravellersObject<TBody extends {}, TResult>(travellers: TBody[]): TResult {
        return travellers.reduce((acc, traveller: any, index: number) => {
            const id = traveller.xId || `T_${index + 1}`;

            acc[id] = {
                ...(traveller as {}),
                id,
                xId: id,
            };

            return acc;
        }, {} as TResult);
    }
}
